export type DocumentStatus = "pending" | "processing" | "ready" | "failed";

export const DOCUMENT_STATUS_LABELS: Record<DocumentStatus, string> = {
  pending: "Pending",
  processing: "Processing",
  ready: "Ready",
  failed: "Failed",
};

export function isDocumentStatusTerminal(status: DocumentStatus): boolean {
  return status === "ready" || status === "failed";
}

/** Client-side Improve is available once the encrypted blob exists or extraction can be retried. */
export function documentStatusAllowsImprove(status: DocumentStatus): boolean {
  return (
    status === "ready" ||
    status === "pending" ||
    status === "failed" ||
    status === "processing"
  );
}

/** Save-as-PDF needs a stored encrypted document, not only a successful extraction. */
export function documentStatusAllowsSavePdf(status: DocumentStatus): boolean {
  return status === "ready" || status === "failed" || status === "processing";
}
